function getTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return;
    }
}
export { getTimezone };
